export const REGION_SESSION = "com.walmart.phronesis.region"

export const CUSTOMER_HABITS_METRIC_SESSION = "CUSTOMER_BEHAVIOR"

const MINUTE = 60000
export const SHOW_EXPIRATION_MODAL_TIME = 45 * MINUTE
export const WAITING_TIME_TO_EXPIRE = 5
export const ONE_SECOND = 1000

export const ADD_ZERO = "0"
export const REMOVE_ZERO = ""

export const SESSION_EXPIRATION = "SESSION_EXPIRATION"
export const REASON_SESSION_EXPIRED = "session expired"

export const MILISECONDS = 1000
export const SECONDS = 60
